<template>
    <base-form @submit="onSubmit">
        <div class="px-6 pt-6 border-b">
            <validator-alert :sid="sid" />

            <h1 class="mb-3 text-lg font-normal font-semibold">
                Go to a profiles dashboard
            </h1>

            <form-item
                :sid="sid"
                :is-required="true"
                name="profile"
            >
                <template slot="label">Profile</template>

                <input-select
                    v-model="form.persona"
                    :options="options"
                    name="persona"
                    placeholder="Select a profile..."
                />
            </form-item>
        </div>

        <base-form-footer
            :is-responsive="false"
            :show-required="false"
            class="rounded-b"
        >
            <base-button
                :is-loading="is_loading"
                class="w-full btn-blue"
            >
                Go to Dashboard
            </base-button>
        </base-form-footer>
    </base-form>
</template>

<script>
    import _ from 'lodash'
    import * as types from '../../../store/types'
    import HeadMixin from '../../../mixins/head'

    export default {
        mixins: [
            HeadMixin
        ],
        props: {
            only: {
                type: String,
                required: false,
                default: null
            },
            redirectWhenEmpty: {
                type: Object,
                required: false,
                default: () => {
                    return { name: 'auth.personas.create' }
                }
            }
        },
        data () {
            return {
                sid: _.uuid(),
                is_loading: false,
                form: {
                    persona: null
                }
            }
        },
        computed: {
            personas () {
                return _.chain(this.$store.getters[types.users.modules.current.getters.item])
                    .get('data.personas.data')
                    .thru(personas => {
                        if (this.only) {
                            personas = _.filter(personas, {
                                object: this.only
                            })
                        }

                        return personas
                    })
                    .value()
            },
            options () {
                return _.map(this.personas, persona => {
                    return {
                        label: persona.name,
                        sublabel: this.$t(`objects.${persona.object}`),
                        value: {
                            object: persona.object,
                            uuid: persona.uuid
                        }
                    }
                })
            }
        },
        created () {
            if (this.personas.length === 0) {
                this.$router.push(this.redirectWhenEmpty)
            }
        },
        methods: {
            head () {
                return {
                    title: 'Select a profile'
                }
            },
            onSubmit () {
                const personaTypes = ['landlord', 'tenant']

                if (!(this.form.persona && personaTypes.includes(this.form.persona.object))) {
                    this.$validator.set({
                        message: 'Whoops!',
                        detail: 'Please check the form for errors.',
                        errors: {
                            persona: [
                                !this.form.persona
                                    ? this.$t('validation.required', { attribute: 'profile type' })
                                    : this.$t('validation.in', { attribute: 'profile type' })
                            ]
                        }
                    }, this.sid)
                } else {
                    this.is_loading = true

                    if (this.form.persona.object === 'landlord') {
                        window.location = this.$laroute.route('dashboard.landlords.overview.index', {
                            landlord: this.form.persona.uuid
                        })
                    } else {
                        window.location = this.$laroute.route('dashboard.tenants.overview.index', {
                            tenant: this.form.persona.uuid
                        })
                    }
                }
            }
        }
    }
</script>
